/**
 * Utilidades para stock-send en el generador (envío desde bodega RESPEL).
 * Clave alineada con `stockSendSlotKey` en mergeWarehouseStockGuideItems.js.
 */
export function guideWarehouseStockSendKey(warehouseId, residueId) {
	return `${String(warehouseId)}__${String(residueId)}`;
}

/**
 * Suma de kilograms_to_send (o QtyItem) por clave bodega+residuo en ítems ya agregados al borrador.
 * @param {Array} items - `validation.values.items`
 * @returns {Record<string, number>}
 */
export function committedKgByStockSendKeyFromItems(items) {
	const out = {};
	for (const item of items || []) {
		const v = item?._module_vars;
		if (!v?._is_warehouse_stock_send) continue;
		const key = guideWarehouseStockSendKey(v.warehouse_id, v.residue_id);
		const kg = Number(v.kilograms_to_send ?? item?.QtyItem ?? 0);
		out[key] = (out[key] || 0) + (Number.isFinite(kg) ? kg : 0);
	}
	return out;
}

/** Quita líneas generadas desde stock consolidado. */
export function withoutWarehouseStockSendItems(items) {
	return (items || []).filter(row => !row?._module_vars?._is_warehouse_stock_send);
}

/** Filtra stock-send y renumera NroLinDet. */
export function withoutWarehouseStockSendItemsRenumbered(items) {
	return withoutWarehouseStockSendItems(items).map((it, i) => ({
		...it,
		NroLinDet: i + 1,
	}));
}
